import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const initialFormState = {
  name: "",
  company: "Concept Magik Website",
  email: "",
  phone: "",
  segment: "Contact Form",
  project_scope: "Website enquiry",
  message: "",
};

const inputClassName =
  "w-full rounded-sm border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-orange-600 focus:bg-white focus:ring-2 focus:ring-orange-200";

export default function ContactForm() {
  const [formData, setFormData] = useState(initialFormState);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/enquiries`, formData);
      if (response.data.email_status === "sent") {
        toast.success("Thanks — your enquiry has been sent.");
      } else {
        toast.success("Your enquiry was saved. Email forwarding will work once the sending domain is verified.");
      }
      setFormData(initialFormState);
    } catch (error) {
      toast.error("We couldn't send your enquiry. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="grid gap-5" onSubmit={handleSubmit} data-testid="contact-form">
      <div className="grid gap-5 md:grid-cols-2">
        <label className="grid gap-2 text-sm font-semibold text-slate-700" data-testid="contact-form-name-field">
          Name
          <input
            className={inputClassName}
            data-testid="contact-form-name-input"
            name="name"
            onChange={handleChange}
            placeholder="Enter Name"
            required
            value={formData.name}
          />
        </label>

        <label className="grid gap-2 text-sm font-semibold text-slate-700" data-testid="contact-form-email-field">
          Email
          <input
            className={inputClassName}
            data-testid="contact-form-email-input"
            name="email"
            onChange={handleChange}
            placeholder="Enter Email"
            required
            type="email"
            value={formData.email}
          />
        </label>

        <label className="grid gap-2 text-sm font-semibold text-slate-700" data-testid="contact-form-phone-field">
          Cell Phone
          <input
            className={inputClassName}
            data-testid="contact-form-phone-input"
            name="phone"
            onChange={handleChange}
            placeholder="Enter Phone Number"
            value={formData.phone}
          />
        </label>
      </div>

      <label className="grid gap-2 text-sm font-semibold text-slate-700" data-testid="contact-form-message-field">
        Message
        <textarea
          className={`${inputClassName} min-h-36 resize-y`}
          data-testid="contact-form-message-input"
          name="message"
          onChange={handleChange}
          placeholder="Enter Your Message"
          required
          value={formData.message}
        />
      </label>

      <div className="flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-6 md:flex-row md:items-center">
        <p className="max-w-xl text-sm text-slate-500" data-testid="contact-form-note">
          Form received.
        </p>
        <button
          className="inline-flex items-center justify-center rounded-sm bg-orange-600 px-6 py-4 text-sm font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-orange-500 disabled:cursor-not-allowed disabled:bg-orange-300"
          data-testid="contact-form-submit-button"
          disabled={submitting}
          type="submit"
        >
          {submitting ? "Submitting Form..." : "Submit Form"}
        </button>
      </div>
    </form>
  );
}
